// extracted by css-extract-rspack-plugin
export default {"root":"NotificationText_root__g72Tm"};